import * as React from "react";
import { ensureGoogleLibrary, hasGoogleMapsKey } from "./googleMapsLoader";

/**
 * Liefert die Google-Places-Library (neue Places API). Das Laden selbst liegt
 * seit der Geokodierung im gemeinsamen `googleMapsLoader` — dort teilen sich
 * `places` und `geocoding` ein Script, einen Key und eine Initialisierung.
 * Key aus import.meta.env.VITE_GOOGLE_MAPS_AUTOCOMPLETE. Ohne Key / bei
 * Ladefehler bleibt `places` null → das Anschrift-Feld verhält sich wie ein
 * normales Texteingabefeld (keine Regression). Lose typisiert (any), da
 * @types/google.maps nicht installiert ist.
 */
export function useGooglePlaces(): { places: any; available: boolean } {
  const [places, setPlaces] = React.useState<any>(null);
  React.useEffect(() => {
    let alive = true;
    const p = ensureGoogleLibrary("places");
    if (!p) return;
    p.then((lib) => {
      console.log("[GMaps] useGooglePlaces: Library aufgelöst", { alive, hasLib: !!lib });
      if (alive && lib) setPlaces(lib);
    });
    return () => {
      alive = false;
    };
  }, []);
  return { places, available: hasGoogleMapsKey() };
}
